import { render, staticRenderFns } from "./TableImage.vue?vue&type=template&id=477ac9cc&"
import script from "./TableImage.vue?vue&type=script&lang=js&"
export * from "./TableImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports